import * as React from 'react'
import { useState } from 'react'
import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'
import Image from 'next/image'
import Link from 'next/link'

import { getAllFilesFrontMatter } from '~/lib/mdx'
import { PostFrontMatter } from '~/types'
import Container from '~/components/Container'
import NotchedCard from '~/components/NotchedCard'
import NewsletterSignup from '~/components/NewsletterSignup'

const url = 'https://mary.ag/blog'
const title = 'Blog - Mary Agrotechnologies'
const description = ''

function NoPosts() {
  return <p className="py-4 mb-24">Sorry, there are no posts yet.</p>
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = await getFilteredSortedPosts()
  return { props: { posts } }
}

export default function BlogPage({ posts }) {
  return (
    <Container className="flex-col">
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{
          url,
          title,
          description
        }}
      />
      <div className="w-full bg-black text-white">
        <header className="w-full pt-24 pb-12 px-6">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-medium text-xl lg:text-2xl break-words leading-normal">
              All Posts
            </h2>
          </div>
        </header>
        <section className="w-full pb-20 px-6">
          <div className="max-w-7xl mx-auto">
            {posts.length > 0 ? (
              posts.map(({ slug, title }) => (
                <div className="w-full" key={slug}>
                  <Link href={`/articles/${slug}`}>
                    <a className="hover:underline">{title}</a>
                  </Link>
                </div>
              ))
            ) : (
              <NoPosts />
            )}
          </div>
        </section>

        <div className="md:hidden -mb-18">
          <Image
            src="/images/blog-page-image-mobile.png"
            alt="MaryAG Newsletter"
            width="100%"
            height="133%"
            layout="responsive"
            objectFit="cover"
            className="aspect-w-3 aspect-h-4"
          />
        </div>
        <div className="relative md:overflow-hidden ">
          <div className="hidden lg:block ">
            <Image
              src="/images/blog-page-image.jpg"
              alt="MaryAG Newsletter"
              width="160%"
              height="90%"
              layout="responsive"
              objectFit="cover"
              className="aspect-w-16 aspect-h-9"
            />
          </div>
          <div className="hidden md:block lg:hidden">
            <Image
              src="/images/blog-page-image.jpg"
              alt="MaryAG Newsletter"
              width="100%"
              height="100%"
              layout="responsive"
              objectFit="cover"
              className="aspect-w-1 aspect-h-1"
            />
          </div>

          <div className="flex flex-row justify-end flex-wrap md:absolute bottom-0 right-0 relative ">
            <NotchedCard
              notchPosition="top-left"
              className="bg-taupe-500 w-full h-96 md:w-165 md:-mb-0 px-6 md:px-28 flex-shrink-0 flex-grow-0 -mb-8 pb-8"
              aspectW={660}
              aspectH={384}
            >
              <NewsletterSignup />
            </NotchedCard>
          </div>
        </div>
      </div>
    </Container>
  )
}

async function getFilteredSortedPosts() {
  const posts = await getAllFilesFrontMatter('blogs')

  return posts
    .filter(
      (post: PostFrontMatter) =>
        process.env.NODE_ENV === 'development' || !!post.publishedAt
    )
    .sort(
      ({ publishedAt: firstDate }, { publishedAt: secondDate }) =>
        Number(new Date(secondDate)) - Number(new Date(firstDate))
    )
}
